import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  collectionFromModel,
  validateCollectionCondition,
  type CollectionState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const COLLECTION = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CollectionState>>,
): ConditionType<CollectionState, Condition.Collection> => ({
  name: "Collections",
  description(state) {
    return `Collections: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<CollectionState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return collectionFromModel(model);
  },
  toModel(state) {
    return { type: Condition.COLLECTION, collections: state };
  },
  valid(state) {
    return validateCollectionCondition(state).valid;
  },
});

export { type CollectionState } from "@redotech/redo-model/return-flow/condition-validate";
